import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './backoffice/components/Layout';
import PrivateRoute from './backoffice/components/PrivateRoute';
import Overview from './backoffice/pages/Overview';
import Villes from './backoffice/pages/villes';
import Categories from './backoffice/pages/categories';
import Evenements from './backoffice/pages/evenements';
import Activites from './backoffice/pages/activites';
import Tickets from './backoffice/pages/tickets';
import Produits from './backoffice/pages/produits';
import Invites from './backoffice/pages/invites';
import TypesPointsVente from './backoffice/pages/types-points-ventes';
import TypesTickets from './backoffice/pages/types-tickets';
import TypesActivites from './backoffice/pages/types-activites';
import PointsVentes from './backoffice/pages/points-ventes';
import Tentes from './backoffice/pages/tentes';
import Login from './backoffice/pages/login';
import Commandes from './backoffice/pages/commandes';
import Users from './backoffice/pages/utilisateurs';
import Configurations from './backoffice/pages/configurations';
import CheckTransactions from './backoffice/pages/commandes/CheckTransactions';
// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import './backoffice/styles/dashboard.css';
import './styles/fonts.css';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route path="/login" element={<Login />} />
        
        {/* Routes protégées du backoffice */}
        <Route
          path="/backoffice"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Overview />} />
          <Route path="villes" element={<Villes />} />
          <Route path="categories" element={<Categories />} />
          <Route path="evenements" element={<Evenements />} />
          <Route path="activites" element={<Activites />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="produits" element={<Produits />} />
          <Route path="invites" element={<Invites />} />
          <Route path="types-points-vente" element={<TypesPointsVente />} />
          <Route path="types-tickets" element={<TypesTickets />} />
          <Route path="types-activites" element={<TypesActivites />} />
          <Route path="points-ventes" element={<PointsVentes />} />
          <Route path="tentes" element={<Tentes />} />
          <Route path="commandes" element={<Commandes />} />
          <Route path="utilisateurs" element={<Users />} />
          <Route path="configurations" element={<Configurations />} />
          <Route path="check-transactions" element={<CheckTransactions />} />
        </Route>

        {/* Route pour gérer les URLs invalides */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
